import * as React from "react";

type Props = {
  onChange: React.ChangeEventHandler;
  value?: number;
  min?: number;
  max?: number;
  postfix?: string;
  prefix?: string;
  color?: string;
  backgroundColor?: string;
  hide_min_max?: boolean;
  min_max_top?: boolean;
  className?: string;
  onClick?: React.MouseEventHandler;
  labels?: Array<string>;
  group_values?: Array<number>;
  width?: string;
  step?: number;
};

export const CustomSliderType3 = ({
  onChange,
  value = 50,
  min = 0,
  max = 100,
  prefix = "",
  postfix = "",
  color = "#203661",
  backgroundColor = "#DDE0E9",
  hide_min_max = false,
  min_max_top = false,
  className = "",
  step = 1,
}: Props): JSX.Element => {
  const newVal = Number(((value - min) * 100) / (max - min));

  const styles = {
    width: "100%",
    background:
      "linear-gradient(to right, " +
      color +
      " 0%, " +
      color +
      " " +
      newVal +
      "%, " +
      backgroundColor +
      " " +
      newVal +
      "%, " +
      backgroundColor +
      " 100%)",
    border: "solid 1px #E7E3E3",
    height: "12px",
  };

  const styles2 = {
    left: `calc(${newVal}% + (${15 - newVal * 0.19}px))`,
  };

  let customClass = "slider_min_max";
  if (!min_max_top) {
    customClass += " below";
  }
  if (hide_min_max) {
    customClass += " display_none";
  }

  return (
    <div className={className + " range-wrap"} style={{ width: "100%" }}>
      <div className={customClass}>
        <div>{prefix + min.toLocaleString() + ""}</div>
        <div>{prefix + max.toLocaleString() + ""}</div>
      </div>
      <input
        type="range"
        className="range slider range_slider"
        style={styles}
        min={min}
        max={max}
        value={value}
        onChange={onChange}
        step={step}
      />
      <output className="bubbleType2" style={styles2}>
        {(prefix ? prefix : "") +
          value.toLocaleString() +
          (postfix ? postfix : "")}
      </output>
    </div>
  );
};
